import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import DashboardButton from '../../pages/Dashboard/DashboardButton';
import Card from '../../design-system/cards/Card';
import LockedContent from '../LockedContent';

const ResponsiveBackgroundImage = ({
  imageSrc,
  aspectRatioHeight,
  aspectRatioWidth,
  children,
}) => (
  <div
    css={css`
      background-image: url(${imageSrc}?q=60&w=1800);
      background-size: cover;
      padding-bottom: ${(aspectRatioHeight / aspectRatioWidth) * 100}%;
      position: relative;
      width: 100%;`}
  >
    {children}
  </div>
);
ResponsiveBackgroundImage.defaultProps = {
  aspectRatioHeight: 9,
  aspectRatioWidth: 16,
};

ResponsiveBackgroundImage.propTypes = {
  children: PropTypes.node.isRequired,
  imageSrc: PropTypes.string.isRequired,
  aspectRatioHeight: PropTypes.number,
  aspectRatioWidth: PropTypes.number,
};

const selectHeadingClassName = (text) => {
  const multipleWords = text.indexOf(' ') > -1;
  const longWord = text.length > 8;

  if (multipleWords) return 'ss_heading-spy-role--multiple-words';
  if (longWord) return 'ss_heading-spy-role--single-word-long';

  return 'ss_heading-spy-role--single-word-regular';
};

const DashboardSpyRoleCard = ({
  title,
  footer,
  spyRoleName,
  spyRoleImage,
  imageLink,
  locked,
  onButtonClick,
}) => (
  <Card>
    <Card.Header>{title}</Card.Header>
    <Card.Body>
      <LockedContent locked={locked}>
        <ResponsiveBackgroundImage
          imageSrc={spyRoleImage}
          aspectRatioWidth={16}
          aspectRatioHeight={9}
        >
          <a href={imageLink} className="ss_pos--center ss_fill-content">
            <h3 className={selectHeadingClassName(spyRoleName)}>
              {spyRoleName}
            </h3>
          </a>
        </ResponsiveBackgroundImage>
      </LockedContent>
    </Card.Body>
    <Card.Footer>
      <DashboardButton
        onClickLocked={onButtonClick}
        locked={locked}
        href={footer.buttonLink}
        secondary
        my0
      >
        {footer.buttonText}
      </DashboardButton>
    </Card.Footer>
  </Card>
);

DashboardSpyRoleCard.propTypes = {
  locked: PropTypes.bool,
  title: PropTypes.string.isRequired,
  spyRoleName: PropTypes.string.isRequired,
  spyRoleImage: PropTypes.string.isRequired,
  imageLink: PropTypes.string.isRequired,
  footer: PropTypes.exact({
    buttonLink: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
  }).isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

DashboardSpyRoleCard.defaultProps = {
  locked: false,
};

export default DashboardSpyRoleCard;
